<div class="edit-modal-overlay" [ngClass]="{'hidden': hidden}" (click)="hideInternal()"></div>

<div class="edit-modal" (window:keyup)="keyup($event)" [ngClass]="{'from-right': hidden, 'edit-modal-md': size === 'md', 'edit-modal-lg': size === 'lg', 'edit-modal-2x': size === '2x', 'edit-modal-xl': size === 'xl', 'edit-modal-full-screen': size === 'full-screen'}">
  <ng-content></ng-content>
</div>